// V177 — Copy / share helpers for the International Time Converter.
export async function copyText(text) {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch { /* fall through to legacy path */ }
    try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand("copy");
        ta.remove();
        return ok;
    } catch {
        return false;
    }
}

/** Returns "shared" | "cancelled" | "unsupported" | "error". */
export async function nativeShare({ title, text, url }) {
    if (typeof navigator === "undefined" || !navigator.share) return "unsupported";
    try {
        await navigator.share(url ? { title, text, url } : { title, text });
        return "shared";
    } catch (e) {
        return e?.name === "AbortError" ? "cancelled" : "error";
    }
}

export const whatsappShareUrl = (text) => `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;
